export const APP_NAME = 'Compare';

export const MOBILE_BREAKPOINT_MAX = 719;
export const DESKTOP_BREAKPOINT_MIN = 720;
export const OLD_MOBILE_BREAKPOINT_MAX = 960;
export const STICKY_PRODUCTS_CONTAINER_HEIGHT = 104;

export const BASE_ROUTE = '/shop/:cc/:lc/tools/compare-products';
export const URL_PARTNUMBERS_DIVIDER = '|';
export const BAZAAR_VOICE_PASS_KEY = 'caa2W9M6aS5cNiMUWK099g7XuTDZDd7youNA0gsroteFs';
export const AVAILABILITY_TAGS_WITH_PRICES = ['ADD_TO_CART', 'PURCHASE_CD', 'NOT_AVAILABLE'];
export const ADD_TO_CART = 'ADD_TO_CART';
export const DISCONTINUED = 'DISCONTINUED';
export const NOT_AVAILABLE_IN_THIS_SITE = 'NOT_AVAILABLE_IN_SITE';
export const NOT_FOUND = 'NOT_FOUND';
export const CARTABLE_STATUSES = ['ADD_TO_CART', 'PURCHASE_CD'];
export const CALL_FOR_MORE_INFORMATION = ['NOT_AVAILABLE', 'DISCONTINUED', 'NOT_AVAILABLE_IN_SITE'];
export const DOWNLOAD = 'DOWNLOAD';
export const PURCHASE_CD = 'PURCHASE_CD';
export const UNRELEASED = 'UNRELEASED';
export const COMPARISON_LOCAL_STORAGE_NAME = 'comparisonList';
export const APC_COMPARISON_SESSION_ID = 'APC_COMPARISON_SESSION_ID';

export const NOTIFICATION_TYPE_INFO = 'info';
export const NOTIFICATION_TYPE_COPIED = 'copied';
export const NOTIFICATION_TYPE_WARNING = 'warning';
export const NOTIFICATION_TYPE_ERROR = 'error';

export const STATIC_NOTIFICATION_TYPE_ERROR = 'staticError';
export const STATIC_NOTIFICATION_TYPE_WARNING = 'staticWarning';
export const STATIC_NOTIFICATION_TYPE_SUCCESS = 'staticSuccess';

export const RUN_TIME_PROPERTY = 'runTime';
export const MAX_CAPACITY_PROPERTY = 'maxCapacity';
export const NOT_SPECIFIED_PROPERTY_VAL = '—';
export const HIGHLIGHT_DIFFERENCES_EXCEPTION_LIST = [
    'isRuntimeGraphNeeded',
    'isEfficiencyGraphNeeded',
    'rbkInterfaces',
    'runTime',
    'maxCapacity',
    'extendedRunOptions',
    'preinstalledCards',
];
